import React from 'react';
import { SALARY_DISCLAIMER, formatSalary, PROFESSIONS } from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const VacanciesPage = () => {
    const { openForm } = useFormModal();

    return (
        <div className="page">
            <div className="container page-container">
                <h1 className="page-title">Вакансии охраны</h1>
                <p className="page-lead">{SALARY_DISCLAIMER}</p>

                <div className="vacancies-list">
                    {PROFESSIONS.map(({
                        title,
                        description,
                        salaryFrom,
                        salaryTo,
                        schedule,
                        requirements,
                        details,
                        image
                    }) => (
                        <article key={title} className="vacancy-card">
                            {image && (
                                <div className="vacancy-card-image-wrap">
                                    <img src={image} alt={title} className="vacancy-card-image" />
                                </div>
                            )}
                            <h2>{title}</h2>
                            <p className="vacancy-salary">{formatSalary(salaryFrom, salaryTo)} в месяц</p>
                            <p>{description}</p>

                            <h3>График</h3>
                            <p>{schedule}</p>

                            <h3>Обязанности</h3>
                            <ul>
                                {details.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>

                            <h3>Требования</h3>
                            <ul>
                                {requirements.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>

                <p className="page-note">
                    Для получения актуальной информации по конкретной вакансии оставьте заявку — мы перезвоним
                    и ответим на вопросы.
                </p>

                <button type="button" className="cta-button" onClick={openForm}>
                    Подать заявку
                </button>
            </div>
        </div>
    );
};

export default VacanciesPage;
